import { IconProps } from "./icon.type";

export function IcImage(props: IconProps) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.83984 16.973C3.83984 17.3407 3.89495 17.7089 4.02539 18.1459L4.0625 18.2699C4.61556 19.9199 6.13851 21.0277 7.85059 21.0277H23.376L22.4121 24.1254C22.1393 25.1786 21.1666 25.8938 20.1016 25.8939C19.8937 25.8938 19.6865 25.8668 19.4854 25.8138L2.94824 21.3363C1.6726 20.9806 0.911738 19.6455 1.24512 18.3578L3.83984 9.60095V16.973ZM24.1602 2.10681C25.6338 2.10699 26.834 3.32005 26.834 4.80994V16.7035C26.8338 18.1933 25.6337 19.4064 24.1602 19.4066H8.11816C6.64469 19.4066 5.44448 18.1934 5.44434 16.7035V4.80994C5.44434 3.31994 6.6446 2.10681 8.11816 2.10681H24.1602ZM8.11816 4.26892C7.82309 4.26892 7.58301 4.51141 7.58301 4.80994V15.015L10.5352 12.0326C11.2656 11.2931 12.4561 11.2931 13.1875 12.0326L14.4814 13.3373L18.4531 8.51697C18.8081 8.08666 19.328 7.83852 19.8818 7.83533C20.4389 7.84815 20.958 8.07464 21.3164 8.49939L24.6943 12.4857V4.80994C24.6943 4.51152 24.4553 4.2691 24.1602 4.26892H8.11816ZM10.792 5.34998C11.9714 5.35018 12.9304 6.31978 12.9307 7.51208C12.9307 8.70459 11.9715 9.67496 10.792 9.67517C9.61235 9.67517 8.65234 8.70467 8.65234 7.51208C8.65257 6.3197 9.61244 5.34998 10.792 5.34998Z"
        fill="#A3A3A3"
      />
    </svg>
  );
}
